import { DefaultPanel } from '../gadgets/panel';
import { Table } from '../gadgets/table';
import { API } from '../libs/api';
import { PageOptions } from '../libs/pager.class';
var LogPage = /** @class */ (function () {
    function LogPage() {
    }
    LogPage.prototype.run = function (finish) {
        PageOptions.setTitle("Aktivitäten und Logs");
        API.getData(["log/list", "users/list/s:name:/s:surname:/s:id:"], function (result) {
            var user_names = new Map();
            result.users_list.forEach(function (e) {
                user_names.set(e.id, e.name + " " + e.surname);
            });
            for (var i = 0; i < result.log_list.length; i++) {
                result.log_list[i].userid = user_names.has(result.log_list[i].userid) ? user_names.get(result.log_list[i].userid) : result.log_list[i].userid;
            }
            var panel = new DefaultPanel("Aktivitäten", undefined, true);
            var table = new Table("usertable", result.log_list);
            table.setColumns([
                { name: "Zeit", data: 'time', style: "width:150px" },
                { name: "Benutzer", data: 'userid', style: "width:10%" },
                { name: "Typ", data: 'type', style: "width:1%" },
                { name: "IP", data: 'ip', style: "width:1%" },
                { name: "Nachricht", data: 'message' }
            ], false);
            panel.addGadget(table);
            panel.appendToContent(function () {
                table.execute(function () {
                    finish();
                }, [[0, "desc"]]);
            });
        });
    };
    return LogPage;
}());
export { LogPage };
